import { render, staticRenderFns } from "./OnboardingTutorial.vue?vue&type=template&id=8457353e&scoped=true&lang=pug&"
import script from "./OnboardingTutorial.vue?vue&type=script&lang=js&"
export * from "./OnboardingTutorial.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingTutorial.vue?vue&type=style&index=0&id=8457353e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8457353e",
  null
  
)

export default component.exports